import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_CLIENTS;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function filterMinify(param = { enable: true }) {
  return wsService.make_post_request(section + "/list-minify", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_post_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function export_filter(params) {
  return wsService.make_post_request(section + "/export", params, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/vnd.ms-excel",
    },
  });
}

export const clientsService = {
  section,
  filter,
  filterMinify,
  remove,
  create,
  update,
  export_filter,
};
